import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import { userAccessCounts } from "@/Constants/common";
import {
  _fetchClientUsersListCount,
  _fetchClientUsersRole,
} from "@/services/clientusers";

const initialState = {
  isUserAccessCountsLoading: false,
  isUserRolesTitleLoading: false,
  typeCount: userAccessCounts,
  roles: [],
  user_title: [],
  allActionByUser: [],
};

export const fetchNewUserRolesData = createAsyncThunk(
  "clientUserAccess/fetchNewUserRolesData",
  async (data, { dispatch }) => {
    dispatch(setUserRoleTitleLoading(true));
    const response = _fetchClientUsersRole();
    response
      .then((res) => {
        const {
          data: { roles },
        } = res;
        dispatch(updateUserRoles(roles || []));
      })
      .catch((error) => {
        return rejectWithValue(error);
      })
      .finally(() => {
        dispatch(setUserRoleTitleLoading(false));
      });
  },
);

export const fetchUserAccessCounts = createAsyncThunk(
  "clientUserAccess/fetchUserAccessCounts",
  async (data, thunkAPI) => {
    // fIRST EXPORT FETCH IN HEADER
    const response = _fetchClientUsersListCount(data);
    response
      .then((res) => {
        const { data } = res;
        let { roles_count: roles = 0, users_count: users = 0 } = data;
        const obj = { roles, users };
        const arr = userAccessCounts.map((ele) => {
          let type = ele.type;
          return {
            ...ele,
            value: obj[type],
          };
        });
        thunkAPI.dispatch(updateTypeCount(arr));
      })
      .catch((error) => {
        return thunkAPI.rejectWithValue(error);
      });
  },
);

const userAccessSlice = createSlice({
  name: "clientUserAccess",
  initialState,
  reducers: {
    setUserAccessCountsLoading: (state, action) => {
      state.isUserAccessCountsLoading = action.payload;
    },
    setUserRoleTitleLoading: (state, action) => {
      state.isUserRolesTitleLoading = action.payload;
    },
    updateUserRoles: (state, action) => {
      state.roles = action.payload;
    },
    updateTypeCount: (state, action) => {
      state.typeCount = action.payload;
    },
    updateUserTitle: (state, action) => {
      state.user_title = action.payload;
    },
    updateAllActionByUser: (state, action) => {
      state.allActionByUser = action.payload;
    },
  },
});

export const {
  setUserAccessCountsLoading,
  updateUserRoles,
  updateTypeCount,
  updateUserTitle,
  setUserRoleTitleLoading,
  updateAllActionByUser,
} = userAccessSlice.actions;

export default userAccessSlice.reducer;
